import api from '../api/axios';

export interface SystemModule {
  id: number;
  moduleId: string;
  name: string;
  description?: string;
  icon?: string;
  isActive: boolean;
  order: number;
}

export interface UserModuleAccess {
  id: number;
  user: any;
  systemModule: SystemModule;
  hasAccess: boolean;
}

const systemModuleService = {
  // Get all modules (admin only)
  getAllModules: async () => {
    const response = await api.get('/system-modules');
    return response.data;
  },

  // Get modules for current user
  getUserModules: async () => {
    const response = await api.get('/system-modules/user-modules');
    return response.data;
  },

  // Create a new module (admin only)
  createModule: async (data: Partial<SystemModule>) => {
    const response = await api.post('/system-modules', { data });
    return response.data;
  },

  // Update a module (admin only)
  updateModule: async (id: number, data: Partial<SystemModule>) => {
    const response = await api.put(`/system-modules/${id}`, { data });
    return response.data;
  },

  // Update module status (admin only)
  updateModuleStatus: async (id: number, isActive: boolean) => {
    const response = await api.put(`/system-modules/${id}/status`, { isActive });
    return response.data;
  },

  // Delete a module (admin only)
  deleteModule: async (id: number) => {
    const response = await api.delete(`/system-modules/${id}`);
    return response.data;
  },

  // Get user's module access
  getUserModuleAccess: async (userId: number) => {
    const response = await api.get(`/user-module-accesses/user/${userId}`);
    return response.data;
  },

  // Set user's module access
  setUserModuleAccess: async (userId: number, moduleId: number, hasAccess: boolean) => {
    const response = await api.post('/user-module-accesses/set-access', {
      userId,
      moduleId,
      hasAccess,
    });
    return response.data;
  },
};

export default systemModuleService;

